import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import PlantsPage from './pages/PlantsPage';
import PlantDetailPage from './pages/PlantDetailPage';
import CareLogPage from './pages/CareLogPage';
import DiaryPage from './pages/DiaryPage';
import StrainsPage from './pages/StrainsPage';
import DiseasesPage from './pages/DiseasesPage';
import NewsfeedPage from './pages/NewsfeedPage';
import SettingsPage from './pages/SettingsPage';
import HarvestsPage from './pages/HarvestsPage';
import CalendarPage from './pages/CalendarPage';
import AdminPage from './pages/AdminPage';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#050A07' }}>
      <div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#050A07' }}>
      <div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:id" element={<ProjectDetailPage />} />
        <Route path="plants" element={<PlantsPage />} />
        <Route path="plants/:id" element={<PlantDetailPage />} />
        <Route path="care-log" element={<CareLogPage />} />
        <Route path="diary" element={<DiaryPage />} />
        <Route path="strains" element={<StrainsPage />} />
        <Route path="diseases" element={<DiseasesPage />} />
        <Route path="newsfeed" element={<NewsfeedPage />} />
        <Route path="harvests" element={<HarvestsPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
